import { NgModule } from '@angular/core';
import {AsyncPipe, CommonModule, DatePipe} from '@angular/common';
import {PipelinesTableComponent} from "./pipelines-subcomponents/pipelines-table/pipelines-table.component";
import {MatButton, MatIconButton} from "@angular/material/button";
import {
  PipelinesShareModalComponent
} from "./pipelines-subcomponents/pipelines-share-modal/pipelines-share-modal.component";
import {
  PipelinesSelectionPanelComponent
} from "./pipelines-subcomponents/pipelines-selection-panel/pipelines-selection-panel.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatIcon} from "@angular/material/icon";
import {PipelinesComponent} from "./pipelines.component";
import {MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle} from "@angular/material/dialog";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatCheckbox} from "@angular/material/checkbox";
import {ReactiveFormsModule} from "@angular/forms";
import {MatButtonToggle, MatButtonToggleGroup} from "@angular/material/button-toggle";
import {MatOptgroup, MatOption} from "@angular/material/core";
import {MatHint, MatPrefix, MatSelect} from "@angular/material/select";
import {MatFormField, MatInput, MatLabel, MatSuffix} from "@angular/material/input";
import {MatDivider} from "@angular/material/list";
import {
  PipelinesFilterModalComponent
} from "./pipelines-subcomponents/pipelines-filter-modal/pipelines-filter-modal.component";
import {
  PipelinesConditionBlockComponent
} from "./pipelines-subcomponents/pipelines-filter-modal/pipelines-condition-block/pipelines-condition-block.component";
import {
  PipelinesSortBlockComponent
} from "./pipelines-subcomponents/pipelines-filter-modal/pipelines-sort-block/pipelines-sort-block.component";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatAutocomplete, MatAutocompleteTrigger} from "@angular/material/autocomplete";
import {
  PipelinesPanelPropertyInfoComponent
} from "./pipelines-subcomponents/pipelines-table/pipelines-table-expanded-panels/pipelines-panel-property-info/pipelines-panel-property-info.component";
import {
  PipelinesPanelProjectAttributesComponent
} from "./pipelines-subcomponents/pipelines-table/pipelines-table-expanded-panels/pipelines-panel-project-attributes/pipelines-panel-project-attributes.component";
import {
  PipelinesPanelKpisComponent
} from "./pipelines-subcomponents/pipelines-table/pipelines-table-expanded-panels/pipelines-panel-kpis/pipelines-panel-kpis.component";
import { PipelinesExportModalComponent } from './pipelines-subcomponents/pipelines-export-modal/pipelines-export-modal.component';
import {DragDropModule} from "@angular/cdk/drag-drop";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from "@angular/material/table";
import {
    PipelinesPanelNotesComponent
} from "./pipelines-subcomponents/pipelines-table/pipelines-table-expanded-panels/pipelines-panel-notes/pipelines-panel-notes.component";
import {
  PipelinesPanelNotesSyndicatedComponent
} from "./pipelines-subcomponents/pipelines-table/pipelines-table-expanded-panels/pipelines-panel-notes-syndicated/pipelines-panel-notes-syndicated.component";
import {
    PipelinesPanelProjectDatesComponent
} from "./pipelines-subcomponents/pipelines-table/pipelines-table-expanded-panels/pipelines-panel-project-dates/pipelines-panel-project-dates.component";
import {
  PipelinesPanelProjectCreditsComponent
} from "./pipelines-subcomponents/pipelines-table/pipelines-table-expanded-panels/pipelines-panel-project-credits/pipelines-panel-project-credits.component";
import {
  PipelinesPanelCreditOutletsComponent
} from "./pipelines-subcomponents/pipelines-table/pipelines-table-expanded-panels/pipelines-panel-credit-outlets/pipelines-panel-credit-outlets.component";
import {
  PipelinesPanelLoansComponent
} from "./pipelines-subcomponents/pipelines-table/pipelines-table-expanded-panels/pipelines-panel-loans/pipelines-panel-loans.component";
import {
  PipelinesPanelPricingDetailsComponent
} from "./pipelines-subcomponents/pipelines-table/pipelines-table-expanded-panels/pipelines-panel-pricing-details/pipelines-panel-pricing-details.component";
import {
  PipelinesPanelEsgComponent
} from "./pipelines-subcomponents/pipelines-table/pipelines-table-expanded-panels/pipelines-panel-esg/pipelines-panel-esg.component";
import {
  PipelinesPanelParticipantsComponent
} from "./pipelines-subcomponents/pipelines-table/pipelines-table-expanded-panels/pipelines-panel-participants/pipelines-panel-participants.component";




@NgModule({
  declarations: [
    PipelinesTableComponent,
    PipelinesComponent,
    PipelinesShareModalComponent,
    PipelinesSelectionPanelComponent,
    PipelinesFilterModalComponent,
    PipelinesConditionBlockComponent,
    PipelinesSortBlockComponent,
    PipelinesPanelPropertyInfoComponent,
    PipelinesPanelProjectAttributesComponent,
    PipelinesPanelKpisComponent,
    PipelinesExportModalComponent
  ],
    imports: [
        CommonModule,
        MatButton,
        MatTooltip,
        DragDropModule,
        MatIcon,
        AsyncPipe,
        MatDialogTitle,
        MatDialogClose,
        MatIconButton,
        MatDialogActions,
        MatDialogContent,
        MatFormField,
        MatSelect,
        MatOption,
        MatButtonToggle,
        MatButtonToggleGroup,
        ReactiveFormsModule,
        MatCheckbox,
        MatDivider,
        DatePipe,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatIconButton,
        MatIcon,
        MatDialogClose,
        MatButton,
        MatFormField,
        MatInput,
        MatLabel,
        MatDatepicker,
        MatDatepickerToggle,
        MatSuffix,
        MatDatepickerInput,
        MatAutocompleteTrigger,
        MatAutocomplete,
        MatTable,
        MatCell,
        MatCellDef,
        MatColumnDef,
        MatHeaderCell,
        MatRow,
        MatRowDef,
        MatHeaderCellDef,
        MatHeaderRow,
        MatHeaderRowDef,
        MatPrefix,
        PipelinesPanelNotesComponent,
        PipelinesPanelNotesSyndicatedComponent,
        PipelinesPanelProjectDatesComponent,
        PipelinesPanelProjectCreditsComponent,
        PipelinesPanelCreditOutletsComponent,
        PipelinesPanelLoansComponent,
        PipelinesPanelPricingDetailsComponent,
        PipelinesPanelEsgComponent,
        PipelinesPanelParticipantsComponent,
        MatHint,
        MatProgressSpinnerModule,
        MatOptgroup,

    ]
})
export class PipelinesModule { }
